// extracted by mini-css-extract-plugin
export default {"header-home":"Home_header-home__ypJ+i","header-style-info":"Home_header-style-info__o1MkB","h1":"Home_h1__uosku","h2":"Home_h2__RSGTo","title-style":"Home_title-style__3Ix7E"};